//include 16

jQuery(function(){

    var privateFunctions = {
        setIsOpenText: function(isOpenTextElement, isOpen) {
            if (isOpen) {
                var text = isOpenTextElement.data("open-text");
                if (text) {
                    isOpenTextElement.html(text).removeClass("error-color").addClass("success-color");
                }
            } else {
                var text = isOpenTextElement.data("closed-text");
                if (text) {
                    isOpenTextElement.html(text).addClass("error-color").removeClass("success-color");
                }
            }
        },
        setIsOpenTime: function(isOpenTimeElement, show, from, to) {
            if (!show) {
                isOpenTimeElement.hide();
            } else {
                var format = isOpenTimeElement.data("format");
                var formatted = format.replace("[0]", from).replace("[1]", to);
                isOpenTimeElement.html(formatted);
            }
        },
        convertToDateTime: function(openingTime) {
            var from = moment(openingTime.from, "HH:mm");
            var to = moment(openingTime.to, "HH:mm");
            if(to.hour() == 0 && to.minute() == 0)
                to = moment("23:59", "HH:mm");
            if (from.isAfter(to)) {
                // ZP 14.01.2020: it was subtract but then the customer noticed that opening hours like 15:00-01:00 for
                //example do not work so we changed it. Request came over Slack
                to = to.add(1, "day");
            }
            return {
                from: from,
                to: to
            };
        },
        getClosest: function(dates) {
            var now = moment();
            if (now.diff(dates.to) < now.diff(dates.from)) return dates.to;
            return dates.from;
        },
        getCurrentlyOpenInterval: function(openingTimes) {
            var information = {
                isOpen: false,
                openFrom: null,
                openTo: null
            };
            if (openingTimes.length == 0) return information;
            var now = moment();
            for (var i in openingTimes) {
                var dates = privateFunctions.convertToDateTime(openingTimes[i]);
                if (now.isBetween(dates.from, dates.to) || now.isSame(dates.from) || now.isSame(dates.to)) {
                    information.isOpen = true;
                    information.openFrom = dates.from.format("HH:mm");
                    information.openTo = dates.to.format("HH:mm");
                    return information;
                } else {
                    var closest = privateFunctions.getClosest(dates);
                    if (information.openFrom == null) {
                        information.openFrom = dates.from.format("HH:mm");
                        information.openTo = dates.to.format("HH:mm");
                    } else {
                        var currentClosest = privateFunctions.getClosest({
                            from: information.openFrom,
                            to: information.openTo
                        });
                        if (now.diff(closest) < now.diff(currentClosest)) {
                            information.openFrom = dates.from.format("HH:mm");
                            information.openTo = dates.to.format("HH:mm");
                        }
                    }
                }
            }
            return information;
        }
    }


    window.pixelpoint.initOpeningHoursText = function(){
        $(".is-open").each(function() {
            var $this = $(this);
            var openingHours = $this.data("opening-hours");
            if (!openingHours || openingHours.length == 0) return;
            var currentDay = openingHours.today;

            var information = null;
            if(!!currentDay)
                information = privateFunctions.getCurrentlyOpenInterval(currentDay.opened);

            var isOpenText = $this.find(".is-open-text");
            if (isOpenText.length > 0) {
                var isOpen = (!!information && !!information.isOpen)?information.isOpen : false;
                privateFunctions.setIsOpenText(isOpenText, isOpen);
            }
            var isOpenTime = $this.find(".is-open-time");
            if (isOpenTime.length > 0) {
                if(!!information){
                    isOpenTime.removeClass("hide");
                    privateFunctions.setIsOpenTime(isOpenTime, currentDay.openToday, information.openFrom, information.openTo);
                }
                else{
                    isOpenTime.addClass("hide");
                }
            }
            $this.addClass("display");
        });
    };

    window.pixelpoint.initOpeningHoursText();

    $(".openinghours-price-box").each(function() {
        var $this = $(this);
        var elementWidth = $this.width();

        $this.find("h6").css("min-width", elementWidth + 'px');
        $this.find(".opening-hours").css("min-width", elementWidth + 'px');
    });

});